<!--输入桩号-->
<template>

  <div class="no-input-box">
    <div class="input-box">
      <div class="no-icon">
        <img src="@/assets/img/number.png"
              alt="">
      </div>
      <div class="no-input">
        <input type="text" ref="input"
                name=""
                id=""
                placeholder="请输入枪ID"
                v-model="value">
      </div>
    </div>
    <pi-button type="primary"
                block
                @click="inputCode">确定</pi-button>

  </div>

</template>

<script>
import {
  getChargeGunInfo,
  getChargePrepareInfo
} from "../../common/api";
export default {
  name: 'home-input-number-page',
  data () {
    return {
      popupVisible: false,
      value: ''
    };
  },
  methods: {
    
    inputCode () {
      if (this.value === '') {
        this.$toast('请输入编号', 'center');
      } else {
        this.onInputNumber(this.value);
      }
    },
    onInputNumber(value) {
      getChargeGunInfo({ gunPkId: value }).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          let json = data.data[0];
          if (json) {
            this.gotoCharge({
              gunPkId: json.gunPkId,
              operatorId: json.operatorId,
              customInfo: "",
              
            });
          } else {
            this.$toast("请输入正确的编号!");
          }
        }
      });
    },
    gotoCharge(formData) {
      //先检查桩能不能用
      formData.enterWay = this.enterWay;
      getChargePrepareInfo(formData)
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            if (!data.code || data.code == "SUCCESS") {
              // 桩没问题，正常跳转
              this.$router.push({
                name: "charge/ready",
                query: formData,
              });
            } else if (data.code == "202002") {
              this.$dialog
                .confirm({
                  message: data.msg,
                  confirmButtonText: "充值",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                .then(() => {
                  this.$router.push({
                    name: "recharge",
                  });
                })
                .catch(() => {});
            } else {
              this.$dialog
                .confirm({
                  message: data.msg,
                  confirmButtonText: "确认",
                  confirmButtonColor: "#14CC80",
                  closeOnPopstate: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
          else {
            this.$dialog
              .alert({
                message: data.msg,
                confirmButtonText: "确定",
                confirmButtonColor: "#14CC80",
                closeOnPopstate: true,
              })
              .then(() => {});
          }
        })
        .catch((error) => {
          console.log(error);
          this.$dialog
            .alert({
              message: "查询桩状态失败",
              confirmButtonText: "确定",
              confirmButtonColor: "#14CC80",
              closeOnPopstate: true,
            })
            .then(() => {});
        });
    },
  },
  mounted () {

  },

};
</script>

<style lang="less" scoped>
.no-input-box {
  background-color: #fff;
  padding: 1rem 0.26rem;
  box-sizing: border-box;
  width: 7.5rem;
  .input-box {
    display: flex;
    margin-bottom: 1rem;
    padding: 0 1rem;
    .no-icon {
      width: 1.42rem;
      text-align: center;
      img {
        width: 0.5rem;
        vertical-align: top;
      }
    }
    .no-input {
      flex: 1;
      input {
        width: 100%;
        font-size: 0.32rem;
        height: 0.44rem;
        border: none;
      }
    }
  }
}
</style>
